import { render, staticRenderFns } from "./UsersTabLabels.vue?vue&type=template&id=20497876"
import script from "./UsersTabLabels.vue?vue&type=script&lang=js"
export * from "./UsersTabLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports